import './App.css';
import Home from './pages/home/Home.jsx';
import Menu from "./pages/menu/Menu";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import About from "./pages/about/About";
import GalleryPage from "./pages/gallery/GalleryPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToHash from "./components/utils/ScrollToHash";

function App() {
    return (
        <BrowserRouter>
            <ScrollToHash />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/chi-siamo" element={<About />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
